import { getEmailAutofill } from '@/lib/globals';
import { appStore } from '@/store';
import { iwcEmailLookup } from './iwcEmailLookup';
import { shouldUseIWC, validateEmail } from './emailLookup';
import { handleSignupSuppress } from './handleSignupSuppress';

export const iwcAutofillEmailLookup = async (): Promise<void> => {
  const { setIsExistingAccount, setLastEmailLookup } =
    appStore.getActions().api;
  const email = appStore.getState().form.email?.value;
  const autoFill = getEmailAutofill();

  const autoFilledEmail = autoFill.ulEmail || autoFill.cartEmail;

  // We only want to run lookup if user didn't change email yet
  if (
    email === autoFilledEmail &&
    validateEmail(autoFilledEmail) &&
    shouldUseIWC()
  ) {
    setLastEmailLookup(email);
    const isExistingAccount = await iwcEmailLookup(autoFilledEmail);
    setIsExistingAccount(isExistingAccount);
    handleSignupSuppress(isExistingAccount);
  }
};
